import { TEnvironmentSettings } from './environment.types';

export const initialBaseContext: TEnvironmentSettings = {
    isProduction: false,
    environment: '',
    baseUrl: '',
    googleTagManagerApiKey: '',
    googleTagManagerScriptUrl: '',
    cookiebotId: '',
    orderApiUrl: '',
    basketApiUrl: '',
    paymentApiUrl: '',
    realexBaseUrl: '',
    propositionApiUrl: '',
    instructUrl: '',
    sanityProjectId: '',
    sanityDataset: '',
    oldMessages: '',
    messages: '',
    propertyApi: '',
    facadeApi: '',
    accountApiUrl: '',
    facadeApiBaseUrl: '',
    outlookSyncApi: '',
    complianceApi: '',
    callCenterPhoneNumber: '',
    baseApiUrl: '',
    expertTeamApi: '',
    onlineAssestsUrl: '',
    reviewsApi: '',
    advertApi: '',
    propertyPortalApi: '',
    imgixAgentUrl: '',
    graphqlApi: '',
    buyerAmlApi: '',
    imgixWebUrl: '',
    agentBookValApi: '',
    scheduling: '',
    schedulingApi: '',
    moneyBackGuaranteeApi: '',
    apiBaseUrl: '',
    offersUrl: '',
    bruce: false,
    valuationApi: '',
    paypalClientId: '',
    paypalUrl: '',
};
